import * as React from "react";
import { Link } from "react-ui";

import { Icon } from "../../Icons/Icon";
import { TestPageObjectHandle } from "../../Services/TestPageObjects/TestPageObjectHandle";
import { useAddSingleUnit } from "../Unit/AddSingleUnitContext";

export interface AddPageProps {
    unitId: string;
    children?: React.ReactNode;
}

export function AddPageButton(props: AddPageProps): JSX.Element {
    const addPage = useAddSingleUnit();

    return (
        <TestPageObjectHandle id={`${props.unitId}_add_page_button`} pageObject={{}}>
            <Link data-tid={`${props.unitId}_add_page_button`} onClick={addPage}>
                <Icon name="PlusIcon" size={14} />
                {props.children || `Заполнить раздел`}
            </Link>
        </TestPageObjectHandle>
    );
}
